import React from 'react';
import '../Footer/Footer.css';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src="logo.svg" alt="Company Logo" />
      </div>
      
      <p className="footer-description">
      Trehan Iris established in the 1950s, Trehan IRIS brings over 60 years of excellence in real estate, delivering iconic projects across Delhi-NCR. Renowned for innovative, sustainable designs, the group has completed 100+ projects, including IRIS Tech Park, IRIS Broadway, and luxury residences, totaling over 15 million sq. ft.
      </p>

      <div className="footer-links">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/layout">Layouts</Link>
        <Link to="/price">Pricelist</Link>
        <Link to="/contact">Contact</Link>
      </div>

      <hr className="footer-line" />
    </footer>
  );
};

export default Footer;
